import React from 'react';
import { registerWidget } from '@okapi/core';
import { createStore, TRootState } from 'store/create-store';
import { TPropsFromParentMicrofront } from 'store/data-from-parent-microfront-slice';
import { GalleryEntryWidget } from '../../common/widgets';

type TDataFromServer = {
  store: TRootState;
  version: string;
};

// eslint-disable-next-line react/function-component-definition
registerWidget<TDataFromServer, TPropsFromParentMicrofront>(`${__NAME__}/root`, state => {
  // store создается на серверной части, а на клиенте он реинициализируется с теми же данными
  const { store } = createStore({
    preloadedState: {
      ...state.store,
    },
  });

  // eslint-disable-next-line react/function-component-definition
  return props => {
    return <GalleryEntryWidget store={store} {...props} />;
  };
});
